export default __webpack_public_path__ + "static/media/244.f86a2153.png";